<a *ngIf="_resource" class="downloadable-resource" [ngClass]="_modifiers" [href]="_resource.file_name" target="_blank">
  <img class="downloadable-resource__image" [src]="_resource.icon" />

  <p class="downloadable-resource__label">{{ _resource.name }}</p>
</a>
